import { TopNews } from '../models/API';
export const calcTopNewsWidth = (line: TopNews): number => {
    let width = 0;
    const divide = 11;
    const fontSize = 14;
    width += line.title.length * fontSize;
    if (!line.multipleData) { return width; }
    for (const subItem of line.multipleData) {
        width += divide;
        width += subItem.title.length * fontSize;
    }
    return width;
};



// WEBPACK FOOTER //
// ./src/utils/calcTopNewsWidth.ts